module.exports = __webpack_public_path__ + "media/images/vp/icon.delete.red-be2aed388bb2935a3b2e2f7b39a1f4c0.svg";